"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areasGetAgentListingsInAreaAreasAgentListingsGet = areasGetAgentListingsInAreaAreasAgentListingsGet;
const encodings_js_1 = require("../lib/encodings.js");
const M = __importStar(require("../lib/matchers.js"));
const primitives_js_1 = require("../lib/primitives.js");
const schemas_js_1 = require("../lib/schemas.js");
const security_js_1 = require("../lib/security.js");
const url_js_1 = require("../lib/url.js");
const errors = __importStar(require("../sdk/models/errors/index.js"));
const operations = __importStar(require("../sdk/models/operations/index.js"));
const shared = __importStar(require("../sdk/models/shared/index.js"));
const async_js_1 = require("../sdk/types/async.js");
/**
 * Get Agent Listings In Area
 *
 * @remarks
 * Get agents listings for an area.
 *
 * ## Valid query parameters
 *
 * <details>
 * <summary>Click to view information on valid query parameters for this endpoint</summary>
 *
 * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
 * with details why they are not valid.
 *
 * | Combination                       | Description                                                                                                                                                 |
 * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
 * | Postcode only                     | Will return only the agents that have listed in the postcode.                                                                                                            |
 * | Outcode only                      | Will return only the agents that have listed in the outcode.                                                                                                             |
 * | Sector only                       | Will return only the agents that have listed in the sector.
 * | Single point parameter and radius | Will return all agents that have listed within the radius of the lat/lon given.                                                                                          |
 * | Multiple point parameters         | Will return all agents that have listed enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
 *
 * </details>
 */
function areasGetAgentListingsInAreaAreasAgentListingsGet(client, security, request, options) {
    return new async_js_1.APIPromise($do(client, security, request, options));
}
async function $do(client, security, request, options) {
    const parsed = (0, schemas_js_1.safeParse)(request, (value) => operations
        .GetAgentListingsInAreaAreasAgentListingsGetRequest$outboundSchema
        .parse(value), "Input validation failed");
    if (!parsed.ok) {
        return [parsed, { status: "invalid" }];
    }
    const payload = parsed.value;
    const body = null;
    const path = (0, url_js_1.pathToFunc)("/areas/agent-listings")();
    const query = (0, encodings_js_1.encodeFormQuery)({
        "filter[listing_type]": payload["filter[listing_type]"],
        "outcode": payload.outcode,
        "point": payload.point,
        "postcode": payload.postcode,
        "radius": payload.radius,
        "sector": payload.sector,
    });
    const headers = new Headers((0, primitives_js_1.compactMap)({
        Accept: "application/json",
    }));
    const requestSecurity = (0, security_js_1.resolveSecurity)([
        {
            fieldName: "Authorization",
            type: "http:bearer",
            value: security?.bearer,
        },
    ], [
        {
            fieldName: "x-api-key",
            type: "apiKey:header",
            value: security?.xApiKey,
        },
    ]);
    const context = {
        options: client._options,
        baseURL: options?.serverURL ?? client._baseURL ?? "",
        operationID: "get_agent_listings_in_area_areas_agent_listings_get",
        oAuth2Scopes: null,
        resolvedSecurity: requestSecurity,
        securitySource: security,
        retryConfig: options?.retries
            || client._options.retryConfig
            || { strategy: "none" },
        retryCodes: options?.retryCodes || ["429", "500", "502", "503", "504"],
    };
    const requestRes = client._createRequest(context, {
        security: requestSecurity,
        method: "GET",
        baseURL: options?.serverURL,
        path: path,
        headers: headers,
        query: query,
        body: body,
        userAgent: client._options.userAgent,
        timeoutMs: options?.timeoutMs || client._options.timeoutMs || -1,
    }, options);
    if (!requestRes.ok) {
        return [requestRes, { status: "invalid" }];
    }
    const req = requestRes.value;
    const doResult = await client._do(req, {
        context,
        errorCodes: ["400", "404", "422", "429", "4XX", "500", "5XX"],
        retryConfig: context.retryConfig,
        retryCodes: context.retryCodes,
    });
    if (!doResult.ok) {
        return [doResult, { status: "request-error", request: req }];
    }
    const response = doResult.value;
    const responseFields = {
        HttpMeta: { Response: response, Request: req },
    };
    const [result] = await M.match(M.json(200, shared.AreaAgentListingsResponse$inboundSchema), M.jsonErr(422, errors.FastAPIErrorAttributes$inboundSchema), M.jsonErr([400, 404, 429], errors.KrakenErrorAttributes$inboundSchema), M.jsonErr(500, errors.KrakenErrorAttributes$inboundSchema), M.fail("4XX"), M.fail("5XX"))(response, req, { extraFields: responseFields });
    if (!result.ok) {
        return [result, { status: "complete", request: req, response }];
    }
    return [result, { status: "complete", request: req, response }];
}
//# sourceMappingURL=areasGetAgentListingsInAreaAreasAgentListingsGet.js.map